import { h } from "./dom";

export interface DialogHandle {
  el: HTMLDialogElement;
  close(): void;
}

/**
 * Opens a modal <dialog> with the given content. Esc and clicks on the backdrop close
 * it; the element is removed from the DOM once closed.
 */
export function openDialog(className: string, ...content: Node[]): DialogHandle {
  const el = h("dialog", { class: `dialog ${className}` }, h("div", { class: "dialog-body" }, ...content));
  el.addEventListener("click", (e) => {
    // Clicks on the ::backdrop target the dialog itself; clicks inside hit .dialog-body.
    if (e.target === el) el.close();
  });
  el.addEventListener("close", () => el.remove());
  document.body.append(el);
  el.showModal();
  return { el, close: () => el.open && el.close() };
}
